module.exports = "/_next/static/images/virtual-card-blue-3172b761bfc97b6a12ce9b4d6e5ee994.svg";